<template lang="html">
    <section class="ficha ficha-documentacion-seguimiento">
        <h2 class="ficha-title" :style="styles.colorBasic">Documentación seguimiento</h2>
      estoy
        <loading class="w-100" v-if="loadingPractica == true"></loading>
        <template v-else>
            <template v-for="(documentacion, key) in dataDocumentacion" v-if="dataDocumentacion.length > 0">
                <article class="documentacion">
                    <h2 v-if="documentacion.nombre">{{documentacion.nombre}}</h2>
                    <p class="fecha">
                        {{documentacion.fecha}} |
                        <span v-if="documentacion.estado" class="status" :type="documentacion.estado"> {{documentacion.estado}}</span>
                    </p>
                    <arrow-link :text="'Ver Adjunto'" :external="true" :to="documentacion.enlace" :blank="true" v-if="documentacion.enlace"></arrow-link>
                    <p class="observacion-text" v-if="documentacion.ObservacionesAlumno">
                        <u>Observaciones alumno: </u>
                        <span v-html="documentacion.ObservacionesAlumno"></span>
                    </p>
                    <p class="observacion-text" v-if="documentacion.ObservacionesTutor">
                        <u>Observaciones tutor: </u>
                        <span v-html="documentacion.ObservacionesTutor"></span>
                    </p>
                    <div class="contenedor-botones row-start" v-if="documentacion.validado == null">
                        <a class="btn -xs" :style="styles.solidPrimary" @click="validar(documentacion, 'validar')">Validar</a>
                        <a class="btn -skull -xs" :style="styles.skull_primary" @click="rechazar(documentacion, 'rechazar')">Rechazar</a>
                    </div>
                </article>


            </template>
            <section class="popup-observaciones row-center" v-if="openPopup">
                <div class="contenedor-popup-observaciones" :style="styles.backgroundWhite">
                    <a class="cerrar -small" title="Salir" @click="cerrarPopup">✕</a>
                    <p class="title-dest">Antes de {{stateDoc}}</p>
                    <p>¿Le gustaría añadir alguna observación?</p>
                    <textarea focus="true" :style="styles.textarea" v-model="observacionesTutor" name="observacionTutor" placeholder="Escribir aquí.."></textarea>
                    <a class="btn" :style="styles.solidPrimary" @click="aceptar">Aceptar</a>
                </div>
            </section>
        </template>
    </section>

</template>

<script lang="js">
    import { mapGetters, mapActions } from 'vuex';
    import loading from '@/components/parts/loading';
    import arrowlink from '@/components/parts/icons/arrow-link';
    export default {
        name: 'ficha-documentacion-seguimiento',
        props: ['dataDocumentacion', 'idPractica'],
        components: {
            'arrow-link': arrowlink,
            'loading': loading
        },
        mounted() {

        },
        data() {
            return {
                openPopup: false,
                stateDoc: '',
                observacionesTutor: '',
                documentoSeguimiento: {
                    "idDocumento": '',
                    "idPractica": this.idPractica,
                    "Observaciones": '',
                    "validado": null
                }
            }
        },
        methods: {
            ...mapActions(['editaDocumentacionSeguimiento']),
            cerrarPopup() {
                this.openPopup = false,
                    this.documentoSeguimiento.idDocumento = '',
                    this.documentoSeguimiento.Observaciones = '',
                    this.documentoSeguimiento.validado = null
            },
            abrirPopup() {
                this.openPopup = true
            },
            validar(doc, state) {
                this.stateDoc = state,
                    this.observacionesTutor = '',
                    this.openPopup = true
                this.documentoSeguimiento = {
                    "idDocumento": doc.id,
                    "idPractica": this.idPractica,
                    "validado": true
                }
            },
            rechazar(doc, state) {
                this.stateDoc = state,
                    this.observacionesTutor = '',
                    this.openPopup = true
                this.documentoSeguimiento = {
                    "idDocumento": doc.id,
                    "idPractica": this.idPractica,
                    "validado": false
                }
            },
            aceptar() {
                this.documentoSeguimiento.Observaciones = this.observacionesTutor,
                    this.editaDocumentacionSeguimiento(this.documentoSeguimiento)
                this.$emit('refresh')
                this.openPopup = false
            }
        },
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                brand: 'getBrand',
                loadingPractica: 'getLoadingPractica',
            })

        }

    }


</script>

<style scoped lang="scss">
    .ficha-documentacion-seguimiento {
        .loading {
            min-height: calc(50vh);
        }

        .popup-observaciones {
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            top: 0;
            right: 0;
            height: auto;
            background: rgba(0, 0, 0, .9);
            padding: 50px 15px;
            z-index: 20;
        }

        .contenedor-popup-observaciones {
            padding: 50px;
            position: relative;
            max-width: 700px;
            width: 100%;


            textarea {
                width: 100%;
                height: 200px;
                padding: 15px;
                border: 0;
                margin-top: 20px;

                &:focus,
                &:focus-visible {
                    border: 0;
                    border-bottom: 1px solid;
                    outline: none;
                }
            }

            p {
                text-align: center;
            }

            .title-dest {
                margin-bottom: 5px;
                font-size: 20px;
                text-align: center;
            }

            .btn {
                margin-top: 20px;
            }
        }

        .documentacion {
            width: 100%;
            display: inline-block;
            text-align: left;
            margin-bottom: 10px;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;

            .contenedor-botones {
                margin: 10px 0;

                .btn.-xs {
                    margin-right: 10px;
                }
            }

            .fecha {
                font-size: 14px;
            }

            .status {
                font-size: 12px;
                text-transform: uppercase;
                display: inline-block;
                font-weight: 700;

                &[type="rechazado"] {
                    color: red;
                }
            }


            h2 {
                font-weight: bold;
                font-size: 16px;
                width: 100%;
                display: inline-block;
                margin-bottom: 5px;
            }

            .observacion-text {
                font-size: 16px;
                width: 100%;
                text-align: left;
                margin-bottom: 5px;
            }

            p:last-of-type {
                margin-bottom: 0;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-documentacion-seguimiento.vue